__turbopack_context__.v({
  "cardAnimation": "yI52Kq_cardAnimation",
  "cardBorder": "yI52Kq_cardBorder",
  "ctaAnimation": "yI52Kq_ctaAnimation",
  "ctaBackground": "yI52Kq_ctaBackground",
  "ctaBorder": "yI52Kq_ctaBorder",
  "fadeInUp": "yI52Kq_fadeInUp",
  "headerAnimation": "yI52Kq_headerAnimation",
  "iconBackground": "yI52Kq_iconBackground",
  "iconColor": "yI52Kq_iconColor",
  "primaryButton": "yI52Kq_primaryButton",
  "secondaryButton": "yI52Kq_secondaryButton",
  "sectionAnimation": "yI52Kq_sectionAnimation",
});
